import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isConnected: false,
        ordens: []
    },
    mutations: {
        setOrdem (state, data) {
            state.ordens = data;
        },
        SOCKET_CONNECT (state) {
            state.isConnected = true;
            console.log("conectado");
        },
        SOCKET_DISCONNECT (state) {
            state.isConnected = false;
        }
    }
});
